module.exports = __webpack_public_path__ + "static/media/folio.08f3e964.png";